import React from 'react'
import ReactModal from 'react-modal'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { datadogLogs } from '@datadog/browser-logs'
import { Capacitor } from '@capacitor/core'

import { currentLang, t } from 'translations'
import { closeModal } from 'store/actions/modals'

import { Button as MerinioButton } from 'ui'

const ErrorImage = {
  fr: 'https://cloud.merinio.com/generic_error_fr.png',
  en: 'https://cloud.merinio.com/generic_error_en.png'
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidMount() {
    // Listen on history change to reset error page
    const unlisten = this.props.history.listen(() => {
      if (this.state.hasError) {
        this.setState({ ...this.state, hasError: false })
        this.props.closeModal()
      }
    })

    // Save history unlistener
    this.setState({ ...this.state, history: { unlisten } })
  }

  // Remove listener for history changes
  componentWillUnmount() {
    if (this.state.history && this.state.history.unlisten) this.state.history.unlisten()
  }

  componentDidCatch(err) {
    datadogLogs.logger.error(err.message, undefined, err)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <ReactModal
          isOpen={this.state.hasError}
          className={`merinio-modal`}
          overlayClassName={`merinio-modal-overlay${Capacitor.isNativePlatform() ? ' is-mobile-app' : ''}`}
          shouldFocusAfterRender
          // These two lines are required to allow closing when the user clicks outside of the modal
          onRequestClose={() => {
            this.setState({ ...this.state, hasError: false })
            this.props.closeModal()
          }}
          shouldCloseOnOverlayClick={true}
        >
          <div className="w-100 h-100 d-flex flex-column">
            <h1>{t('SOMETHING_WENT_WRONG')}</h1>
            <img src={ErrorImage[currentLang()]} alt="Error" className="rounded mx-auto d-block img-fluid error-image pt-3" />
            <MerinioButton
              type="button"
              color="secondary"
              onClick={() => {
                this.setState({ ...this.state, hasError: false })
                this.props.closeModal()
              }}
              outlined
            >
              {t(`actions.CLOSE`)}
            </MerinioButton>
          </div>
        </ReactModal>
      )
    }

    return this.props.children
  }
}

const mapStateToProps = () => ({})
const mapDispatchToProps = dispatch => ({ closeModal: () => dispatch(closeModal()) })

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary))
